import { KEYSHORTCUTS_FETCH } from './actions.type';
import {
  KEYSHORTCUTS_CURRENT_ADD,
  KEYSHORTCUTS_CURRENT_REMOVE,
  WINDOW_API_ERROR_SHOW
} from './mutations.type';
import { Api as ApiSkrotyKlawiszowe } from '../api/api-ustawienia-systemowe';

import KeyShortcutsListener from '../common/keyShortcutsListener';
import {
  KeysTranslation,
  KeyShortcutPermissions
} from '../common/keyShortcuts';

const keyShortcutsApi = new ApiSkrotyKlawiszowe();

const initialState = {
  currentShortcuts: []
};

export const state = Object.assign({}, initialState);

export const actions = {
  [KEYSHORTCUTS_FETCH](context) {
    const listener = new KeyShortcutsListener();

    keyShortcutsApi
      .getSettingsSkrotyKlawiszowe({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null
      })
      .then(response => {
        response.body.skroty_klawiszowe.forEach(x => {
          let keys = [];

          if (x.klawisz) {
            keys.push(x.klawisz);
          }

          if (x.modyfikator) {
            keys.push(x.modyfikator);
          }

          if (keys.length) {
            listener.watch(
              x.czynnosc,
              function() {
                context.commit(KEYSHORTCUTS_CURRENT_ADD, x.czynnosc);
              },
              function() {
                context.commit(KEYSHORTCUTS_CURRENT_REMOVE, x.czynnosc);
              },
              keys
            );

            const key =
              KeysTranslation.findIndex(y => y.key === x.klawisz) !== -1
                ? KeysTranslation.find(y => y.key === x.klawisz).name
                : x.klawisz;
            const modifier =
              KeysTranslation.findIndex(y => y.key === x.modyfikator) !== -1
                ? KeysTranslation.find(y => y.key === x.modyfikator).name
                : x.modyfikator;
            activeShortcutsList.push({
              key: key,
              modifier: modifier,
              action: x.nazwa,
              permissionId: KeyShortcutPermissions[x.czynnosc]
            });
          }
        });
      })
      .catch(error => context.commit(WINDOW_API_ERROR_SHOW, error));
  }
};

export const mutations = {
  [KEYSHORTCUTS_CURRENT_ADD](state, shortcut) {
    if (state.currentShortcuts.indexOf(shortcut) < 0) {
      state.currentShortcuts.push(shortcut);
    }
  },
  [KEYSHORTCUTS_CURRENT_REMOVE](state, shortcut) {
    if (state.currentShortcuts.find(x => x === shortcut)) {
      state.currentShortcuts = state.currentShortcuts.filter(
        x => x !== shortcut
      );
    }
  }
};

export const activeShortcutsList = [];

const getters = {
  currentShortcuts(state) {
    return state.currentShortcuts;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
